import React from 'react';

export default function IconHotlist() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={26}
      height={26}
      fill="none"
    >
      <g clipPath="url(#a)">
        <path fill="none" d="M0 0h26v26H0z" />
        <g
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
          clipPath="url(#b)"
        >
          <path d="M21.753 15.223c0 4.74-3.92 8.598-8.753 8.598-4.832 0-8.753-3.843-8.753-8.598 0-5.434 5.203-8.182 7.117-12.427.324-.71 1.281-.834 1.744-.216 1.25 1.605 2.949 4.43 2.563 7.518-.108.895.849 1.497 1.59.988.37-.263.772-.603 1.158-1.066.401-.478 1.173-.478 1.559.031a8.5 8.5 0 0 1 1.76 5.172h.015Z" />
          <path d="M10.653 12.017c-5.666 5.548 2.438 8.028 1.341 11.651 3.042.36 6.994-2.435 4.802-5.472-2.193-3.037-3.704-.827-6.143-6.179Z" />
        </g>
      </g>
      <defs>
        <clipPath id="a">
          <path fill="none" d="M0 0h26v26H0z" />
        </clipPath>
        <clipPath id="b">
          <path fill="none" d="M.65.65h24.7v24.7H.65z" />
        </clipPath>
      </defs>
    </svg>
  );
}
